export default __webpack_public_path__ + "static/media/Ficha_Landmarc-1.65176bfd.png";